export default __webpack_public_path__ + "static/media/lesson.550b085b.svg";